import { CardContainer, ModalOpenButton } from "@msys/ui";
import { ChevronRight as ChevronRightIcon } from "@mui/icons-material";
import { Button, Stack } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ModifyOrganisationPurchaseOrdersTextsModal } from "../modals/ModifyOrganisationPurchaseOrdersTextsModal.js";

interface Props {
  organisationId: string;
}

export const OrganisationPurchaseOrderSettingsBox = ({
  organisationId,
}: Props) => {
  const { t } = useTranslate("OrganisationSettings");

  return (
    <CardContainer isExpandable title={t("Purchase order PDF settings")}>
      <Stack
        spacing={1}
        direction="column"
        sx={{
          p: 1,
          width: "100%",
        }}
      >
        <div>
          <ModalOpenButton
            Modal={ModifyOrganisationPurchaseOrdersTextsModal}
            modalProps={{
              organisationId,
              title: t("Customize purchase order text"),
            }}
          >
            <Button
              type="button"
              color="secondary"
              variant="text"
              size="small"
              endIcon={<ChevronRightIcon />}
            >
              {t("Customize purchase order text")}
            </Button>
          </ModalOpenButton>
        </div>
      </Stack>
    </CardContainer>
  );
};
